import Widget from "lib/ui/Widget";
import Button from "lib/ui/controls/Button";
import { Observable, observe } from "lib/reactive";
import InteractionLayer from "lib/gamemap/interaction/InteractionLayer";
import jquery from "jquery";
import { C } from "../../../lib/ui/constructors";
export class ActionBar extends Widget {
    constructor(buttons) {
        super();
        this.addClass("ctr-actionbar");
        this.append(...buttons);
    }
}
(function (ActionBar) {
    var observe_combined = Observable.observe_combined;
    var cls = C.cls;
    class ActionBarButton extends Button {
        constructor(icon, activation) {
            super();
            this.icon = icon;
            this.activation = activation;
            this._activeInteraction = observe(null);
            this.cooldown = observe(0);
            this.hotkey = observe("");
            this._activeInteraction.subscribe((i) => {
                this.render();
                if (i)
                    i.onEnd(() => this._activeInteraction.set(null));
            });
            this.onClick(async (e) => {
                if (this._activeInteraction.value())
                    this._activeInteraction.value().cancel();
                else
                    this.trigger(e);
            });
            observe_combined({
                cd: this.cooldown,
                hk: this.hotkey
            }).subscribe(() => {
                this.render();
            }, true);
        }
        async trigger(e = undefined) {
            if (!this._activeInteraction.value()) {
                let activated = await this.activation(e);
                if (activated instanceof InteractionLayer)
                    this._activeInteraction.set(activated);
            }
        }
        render() {
            this.empty();
            this.addClass("ctr-action-bar-button")
                .append(jquery(`<img src='${this.icon}'>`))
                .css("position", "relative");
            if (this.cooldown.value() > 0 || this._activeInteraction.value()) {
                c("<div class='ctr-cooldown-overlay-shadow'></div>").appendTo(this);
                if (this.cooldown.value() > 0) {
                    cls("ctr-cooldown-overlay").text(this.cooldown.value() + "t")
                        .appendTo(this);
                }
            }
            if (this.hotkey.value() != "") {
                cls("ctr-hotkey-overlay").text(this.hotkey.value())
                    .appendTo(this);
            }
            if (this._activeInteraction.value()) {
                cls("ctr-cooldown-overlay-cancel").text("X")
                    .appendTo(this);
            }
        }
        setHotKey(key) {
            this.hotkey.set(key);
            return this;
        }
    }
    ActionBar.ActionBarButton = ActionBarButton;
})(ActionBar || (ActionBar = {}));
